import { useHasPermission } from "../../auth/useClaims";

// Full per-action permission set (per direct instruction: "as usual", not
// just View/ViewAll) - these booleans only decide whether to SHOW a
// control, the server remains the authority (Quotation.EditApproved in
// particular mirrors Stock.EditApprovedLpo's own client-side disclaimer).
export const useCanManagePrototype = () => useHasPermission("Quotation.ManagePrototype");
export const useCanCreateQuotation = () => useHasPermission("Quotation.Create");
export const useCanEditQuotation = () => useHasPermission("Quotation.Edit");
export const useCanEditApprovedQuotation = () => useHasPermission("Quotation.EditApproved");
export const useCanApproveQuotation = () => useHasPermission("Quotation.Approve");
export const useCanCancelQuotation = () => useHasPermission("Quotation.Cancel");
export const useCanSendQuotation = () => useHasPermission("Quotation.Send");
export const useCanViewAllQuotations = () => useHasPermission("Quotation.ViewAll");
export const useCanViewQuotations = () => useHasPermission("Quotation.View");
